import { Button, Table, Layout, Flex, Modal, message, Select } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { setTokens } from "../features/auth/authSlice";
import {
  CopyTwoTone,
  DeleteTwoTone,
  EditTwoTone,
  PlusOutlined,
  SendOutlined,
  ArrowLeftOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import {
  useDeleteEmailTemplateMutation,
  useDuplicateEmailTemplateMutation,
  useGetAllEmailTemplatesQuery,
  useLazyGetSiteInfoQuery,
  useTestEmailMutation,
  useMoveEmailTemplateMutation,
} from "../features/mailer/mailerApiSlice";
import moment from "moment/moment";
import LoadingComponentAntD from "../components/loadingCompAntd/LoadingComponentAntD";
import { setSiteInfor } from "../store/slice/siteInfoSlice";
import { Input } from "antd";

const { Content } = Layout;
const { Search } = Input;
function AllEmailTemplates() {
  const [getSiteInfo] = useLazyGetSiteInfoQuery();
  const dispatch = useDispatch();
  const [headersReady, setHeadersReady] = useState(false);
  const { user_token, auth, viewType, folderName } = useParams();
  const navigate = useNavigate();
  const storeAuth = useSelector((state) => state.auth);
  const siteInfoStore = useSelector((state) => state.siteInfoStore.info);
  const [messageApi, contextHolder] = message.useMessage();
  const [dataList, setDataList] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [moduleName, setModuleName] = useState(null);
  const [deleteEmailTemplate] = useDeleteEmailTemplateMutation();
  const [duplicateEmailTemplate] = useDuplicateEmailTemplateMutation();
  const [moveEmailTemplate] = useMoveEmailTemplateMutation();
  const [testEmail] = useTestEmailMutation();
  const storeBaseUrl = useSelector((state) => state.baseUrl);
  const [search, setSearch] = useState("");
  const [folders, setFolders] = useState();
  const [moveModalVisible, setMoveModalVisible] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);

  const navigateFolder = () => {
    navigate(`/${auth}/${user_token}/${viewType}`);
  };

  useEffect(() => {
    if (storeAuth?.authBearer && storeAuth?.token) {
      setHeadersReady(true);
    }
  }, [storeAuth, storeBaseUrl.value]);

  const { data, error } = useGetAllEmailTemplatesQuery(folderName, {
    skip: !headersReady,
  });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user_token && auth && viewType) {
      dispatch(
        setTokens({
          user: null,
          token: user_token,
          auth,
          viewType,
        })
      );
    }
  }, [user_token, auth, viewType]);

  useEffect(() => {
    if (user_token && auth) {
      const fetchAllTemps = async () => {
        try {
          if (data) {
            if (data?.status) {
              const newData = data.templates.map((template, index) => ({
                ...template,
                serial: index + 1,
                created_at: moment(template.created_at).format("ll"),
                key: template.id,
              }));
              setFolders(data.folders);
              setDataList(newData);
              setFilterList(newData);
              setModuleName(data?.module_name);
              setTimeout(() => {
                setLoading(false);
              }, 3000);
              setLoading(false);
            }
            if (!data?.status) {
              console.log("!data.status");
              if (data?.message) {
                errorMsg(data?.message);
              }
            }
          }
          if (error) {
            console.log("error::", error);
          }
        } catch (error) {
          console.log("catch-error::", error);
        } finally {
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        }
      };
      fetchAllTemps();
    }
  }, [data, error]);

  useEffect(() => {
    const fetchSiteInfo = async () => {
      try {
        const { data, error } = await getSiteInfo();
        if (data) {
          dispatch(setSiteInfor(data));
        }
        if (error) {
          console.log("site-data::", error);
        }
      } catch (error) {}
    };

    if (!headersReady) {
      fetchSiteInfo();
    }
  }, [getSiteInfo, storeAuth, headersReady]);

  const start = () => {
    setLoading(true);
    setTimeout(() => {
      setSelectedRowKeys([]);
      setLoading(false);
    }, 2000);
  };
  useEffect(() => {
    start();
  }, []);

  const columns = [
    {
      title: "Sr#",
      dataIndex: "serial",
      key: "serial",
      width: "22%",
      align: "center",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text, record) => (
        <Flex gap="middle" vertical>
          <Flex wrap gap="middle" justify="left">
            <Button type="link" onClick={() => navigateToUpdate(record.id)}>
              {record.name}
            </Button>
          </Flex>
        </Flex>
      ),
    },
    {
      title: "User",
      dataIndex: "added_by",
      key: "user",
      align: "left",
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      key: "created_at",
      align: "left",
    },
    {
      title: "Action",
      dataIndex: "",
      width: "40%",
      key: "x",
      align: "center",
      render: (key) => (
        <Flex gap="middle" vertical>
          <Flex wrap gap="middle" justify="center">
            <SwapOutlined
              twoToneColor="#52c41a"
              onClick={() => handleMoveTemplate(key.id, key.category_name)}
            />
            <EditTwoTone onClick={() => navigateToUpdate(key.id)} />
            <CopyTwoTone
              twoToneColor="#52c41a"
              onClick={() => handleDuplicateTemp(key.id)}
            />
            <DeleteTwoTone
              twoToneColor="#eb2f96"
              onClick={() => handleDelete(key.id)}
            />
            <SendOutlined
              rotate={-45}
              onClick={() => handleTestEmailTemp(key.id)}
              style={{ fontSize: "16px", color: "#08c" }}
            />
          </Flex>
        </Flex>
      ),
    },
  ];

  const successMsg = (message) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };

  const errorMsg = (message) => {
    messageApi.open({
      type: "error",
      content: message,
    });
  };

  const handleDelete = (record) => {
    Modal.confirm({
      title: "Are you sure you want to delete this template?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      centered: true,
      keyboard: true,
      maskClosable: true,
      confirmLoading: true,
      onOk: async () => {
        try {
          const { data, error } = await deleteEmailTemplate(record);
          if (data) {
            successMsg(data?.message);
          }
          if (error) {
            console.log("error", error);
            errorMsg(error?.data?.message);
          }
        } catch (error) {
          console.error("Oops errors!", error);
        }
      },
    });
  };

  const handleMoveTemplate = (tempID, category_name) => {
    setSelectedTemplateId(tempID);
    setMoveModalVisible(true);
    setSelectedFolder(category_name);
  };

  const handleDuplicateTemp = (tempID) => {
    Modal.confirm({
      title: "Are you sure you want to duplicate this template?",
      okText: "Yes",
      okType: "primary",
      cancelText: "No",
      centered: true,
      keyboard: true,
      maskClosable: true,
      confirmLoading: true,
      onOk: async () => {
        try {
          const { data, error } = await duplicateEmailTemplate(tempID);
          if (data) {
            successMsg(data?.message);
          }
          if (error) {
            console.log("error", error);
            errorMsg(error?.data?.message);
          }
        } catch (error) {
          console.error("Oops errors!", error);
        }
      },
    });
  };
  const handleTestEmailTemp = (tempID) => {
    Modal.confirm({
      title: "Are you sure you want to test this template?",
      okText: "Yes",
      okType: "primary",
      cancelText: "No",
      centered: true,
      keyboard: true,
      maskClosable: true,
      confirmLoading: true,
      onOk: async () => {
        try {
          const body = {
            user_id: siteInfoStore.user.id,
            template_id: tempID,
          };
          const { data, error } = await testEmail(body);
          if (data) {
            successMsg(data?.message);
          }
          if (error) {
            console.log("error", error);
            errorMsg(error?.data?.message);
          }
        } catch (error) {
          console.error("Oops errors!", error);
        }
      },
    });
  };

  const navigateCreate = () => {
    navigate(`/${auth}/${user_token}/${viewType}/add/${folderName}`);
  };

  const navigateToUpdate = (id) => {
    navigate(`/${auth}/${user_token}/${viewType}/edit/${id}`);
  };

  const onChange = (value, _e, info) => setSearch(value.target.value);

  useEffect(() => {
    const result = dataList.filter((temp) => {
      return temp?.name.toLowerCase().match(search.toLowerCase());
    });
    setFilterList(result);
  }, [search, dataList]);

  return (
    <>
      {loading && <LoadingComponentAntD content={"Loading"} />}
      {contextHolder}
      <Content style={{ padding: "0 48px" }}>
        <div className="container">
          <div className="table-enter-leave-demo-action-bar">
            <Flex gap="middle" vertical>
              <Flex wrap gap="middle" justify="space-between">
                <Button type="primary" onClick={navigateFolder}>
                  <ArrowLeftOutlined />
                  Back to Folders
                </Button>
                {moduleName && (
                  <>
                    <Button type="primary" onClick={navigateCreate}>
                      <PlusOutlined />
                      Create
                    </Button>
                  </>
                )}
              </Flex>
            </Flex>
          </div>
          <div className="table-enter-leave-demo-action-bar">
            <Flex gap="middle" vertical>
              <Flex wrap gap="middle" justify="space-between" align="center">
                <h2 className="m-0">
                  <b>{folderName}</b> (Templates)
                </h2>
                {moduleName && (
                  <>
                    <Search
                      placeholder="search by name"
                      onChange={onChange}
                      style={{ width: 300 }}
                    />
                  </>
                )}
              </Flex>
            </Flex>
          </div>

          <Table
            pagination={{
              position: ["none", "bottomCenter"],
              pageSizeOptions: ["10", "20", "25", "30"],
              showSizeChanger: true,
              locale: { items_per_page: "" },
            }}
            loading={loading}
            bordered={true}
            scroll={{
              y: 400,
            }}
            className="custom-table-class"
            virtual={true}
            columns={columns}
            dataSource={filterList}
          />
        </div>
      </Content>
      <Modal
        title="Move Template to Folder"
        open={moveModalVisible} // ✅ use `open` instead of `visible`
        onCancel={() => setMoveModalVisible(false)}
        onOk={async () => {
          await moveEmailTemplate({
            template_id: selectedTemplateId,
            folder: selectedFolder,
          });
          setMoveModalVisible(false);
        }}
        okText="Move"
        cancelText="Cancel"
      >
        <Select
          style={{ width: "100%" }}
          onChange={(value) => setSelectedFolder(value)}
          value={selectedFolder}
          options={
            folders &&
            folders.map((folder) => ({
              value: folder.name,
              label: folder.name,
            }))
          }
          placeholder="Select Folder"
        />
      </Modal>
    </>
  );
}

export default AllEmailTemplates;
